import React, { useEffect, useState } from 'react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 50);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="bg-black text-white py-1 px-3 text-center sticky top-0 z-50" data-id="element-237">
      <p className="font-sans font-semibold text-[11px] md:text-xs tracking-wide" data-id="element-238">
        <span className="text-orange" data-id="element-239">
          ⏳ OFFER EXPIRES IN: {formattedTime}
        </span>{' '}
        <span className="mx-1" data-id="element-240">|</span>
        🔥 ONLY 3 SPOTS LEFT TODAY
      </p>
    </div>;
}